import React, { useContext } from "react";
import AppBar from "../components/headerNav/HeaderNav";
import { Container } from "react-bootstrap";
import { Grid } from "@material-ui/core";
import { AdminContextProvider } from "../context/DeliveryContext";
import { ListView } from "../components/delivery-management/ListView";
import { UserContext } from "../context/UserContext";
import "../styles/deliverylist.scss";
import Footer from "../components/footer/Footer";
import { UserRoles } from "../constants/UserRoles";
import CookieConsentBanner from "../components/cookie-consent/CookieConsentBanner";

const DeliveryManagement = () => {
  const { userRole } = useContext(UserContext);

  return userRole === UserRoles.ADMIN || userRole === UserRoles.SUPERADMIN || userRole === UserRoles.GLOBALADMIN ? (
    <Container fluid className="listContainer">
      <AdminContextProvider>
        <Grid container>
          <AppBar />
          <ListView />
          <Footer />
          <CookieConsentBanner />
        </Grid>
      </AdminContextProvider>
    </Container>
  ) : null;
};
export default DeliveryManagement;
